import React from 'react';
import $ from 'jquery';
import styled from 'styled-components';

const Title = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  font-style: italic;
  color: var(--color-gunmetal);
  padding-top: 10px;
`;

const Info = styled.div`
  padding-top: 20px;
  padding-bottom: 30px;
  font-family: BrandonGrotesque-Regular;
  font-size: 18px;
  text-align: center;
  color: #555555;
`;

const ModalButton = styled.div`
  width: 50%;
  height: 40px;
  text-align: center;
  display: inline-block;
  line-height: 40px;
  font-family: BrandonGrotesque-Regular;
  font-size: 18px;
  letter-spacing: 0.2px;
  text-align: center;
  cursor: pointer;
  color: ${(props) => (props.confirm ? '#ffffff' : '#909798')};
  background-color: ${(props) => (props.confirm ? '#415859' : '#eeeeee')};
`;

function ModalQuestion(props) {
  return (
    <div className="modal fade" id={props.id} aria-hidden="true">
      <div className="modal-dialog" role="document">
        <div className="modal-content" style={{ width: '352px' }}>
          <div style={{ paddingTop: '10px' }}>
            <Title>{props.title}</Title>
            <Info>{props.children}</Info>
            <ModalButton
              onClick={() => {
                if (props.cancelFunction) props.cancelFunction();
                $(`#${props.id}`).modal('hide');
              }}
            >
              {props.leftName}
            </ModalButton>
            <ModalButton
              confirm
              onClick={() => {
                props.function();
                $(`#${props.id}`).modal('hide');
              }}
            >
              {props.rightName}
            </ModalButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalQuestion;
